<template>
  <div class="manage-applications__flex-box">
    <div class="manage-applications__left-column">
      <div
        class="manage-applications__flex-box manage-applications__flex-right"
      >
        <p class="manage-applications__filter-text">Filter by:</p>
        <!-- Criteria One -->
        <DropdownSelection
          dropdown-type="filter"
          dropdown-name="criteria1"
          :options="dropdownOptions.criteria"
          placeholder="Criteria 1"
          @dropdownChange="updateFilters"
        ></DropdownSelection>

        <!-- Criteria Two -->
        <DropdownSelection
          dropdown-type="filter"
          dropdown-name="criteria2"
          :options="secondCriteria(criteria1Filter)"
          placeholder="Criteria 2"
          @dropdownChange="updateFilters"
        ></DropdownSelection>

        <!-- Assigned to -->
        <DropdownSelection
          dropdown-type="filter"
          dropdown-name="assignedTo"
          :options="dropdownOptions.assignedTo"
          placeholder="Assigned to"
          @dropdownChange="updateFilters"
        ></DropdownSelection>

        <!-- Status -->
        <DropdownSelection
          dropdown-type="filter"
          dropdown-name="status"
          :options="dropdownOptions.status"
          placeholder="Status"
          @dropdownChange="updateFilters"
        ></DropdownSelection>
      </div>

      <div class="manage-applications__tables">
        <GenericTable
          v-if="tableData(accounts).length"
          :table-header="AuditAccountsHeader"
          color-scheme="orange"
          :is-load-more="isLoadMoreShown"
          :column-ratio="[3, 6, 10, 30, 30, 11, 10]"
          :loading-status="loadMoreStatus.name"
          :loading-status-active="loadMoreStatus.type === 'rejected'"
          @loadMoreTableRows="$emit('load-more', 'rejected')"
        >
          <GenericTableRow
            v-for="(account, index) in tableData(accounts)"
            :key="index"
            :column-ratio="[3, 6, 10, 30, 30, 11, 10]"
            @dropdown-open="
              $emit('get-uploaded-images', {
                accountId: account.account_id,
                tableName: 'closedApplicants',
              })
            "
          >
            <template #column-1>
              <div class="generic-table__checkbox">
                <input
                  v-model="selectedAccounts"
                  :value="account.junifer_account_number"
                  type="checkbox"
                  @click.stop
                />
              </div>
            </template>
            <template #column-2>
              <span class="generic-table__account-id">
                {{ account.junifer_account_number }}
              </span>
            </template>
            <template #column-3>
              {{ account.primary_whd_criterion_text }}
            </template>
            <template #column-4>
              {{ account.secondary_whd_criterion_text }}
            </template>
            <template #column-5>
              {{ account.agent }}
            </template>
            <template #column-6>
              <span :class="getLabelClass(account.ark_status)">
                {{ getArkStatus(account.ark_status) }}
              </span>
            </template>

            <template #dropdown>
              <form
                class="generic-table__dropdown"
                @submit.prevent="submitAccountUpdate($event, account)"
              >
                <h3>
                  <strong>First name: </strong>
                  {{ account.first_name }}
                </h3>
                <h3>
                  <strong>Last name: </strong>
                  {{ account.family_name }}
                </h3>
                <h3>
                  <strong>Email: </strong>
                  {{ account.email }}
                </h3>
                <h3>
                  <strong>Contact number: </strong>
                  {{ account.phone_number }}
                </h3>
                <h3>
                  <strong>Supply address: </strong>
                  {{ account.customer_details.address }},
                  {{ account.customer_details.postcode }}
                </h3>
                <h3>
                  <strong>Communication preference: </strong>
                  {{ account.communication_preference }}
                </h3>

                <h3 v-if="account.images">
                  <strong>Eligibility proof: </strong>
                  <strong v-if="account.images.length === 0">
                    No documents uploaded
                  </strong>
                  <a
                    v-else-if="account.images.length === 1"
                    href="javascript:;"
                    @click="openProofModal(account.images[0])"
                  >
                    {{ account.images[0].name }}
                  </a>
                  <div v-else class="generic-list">
                    <ul>
                      <li
                        v-for="(image, imageIndex) in account.images"
                        :key="imageIndex"
                      >
                        <a href="javascript:;" @click="openProofModal(image)">
                          {{ account.images[imageIndex].name }}
                        </a>
                      </li>
                    </ul>
                  </div>
                </h3>

                <div class="generic-table__customer-criteria">
                  <h3>
                    <strong>Update customer criterias</strong>
                  </h3>
                  <p>Criteria One</p>
                  <DropdownSelection
                    dropdown-name="criteria1"
                    :options="dropdownOptions.criteria"
                    :set-selected="account.primary_whd_criterion_id.toString()"
                    :has-placeholder="false"
                    @dropdownChange="registerChange($event, account)"
                  ></DropdownSelection>

                  <p>Criteria Two</p>
                  <DropdownSelection
                    dropdown-name="criteria2"
                    :options="
                      secondCriteria(
                        account.primary_whd_criterion_id.toString(),
                      )
                    "
                    :set-selected="
                      account.secondary_whd_criterion_id.toString()
                    "
                    :has-placeholder="false"
                    @dropdownChange="registerChange($event, account)"
                  ></DropdownSelection>
                </div>

                <div class="generic-table__flex-box">
                  <div class="generic-table__half-left-column">
                    <h3>
                      <strong>Update assigned agent</strong>
                    </h3>
                    <DropdownSelection
                      dropdown-name="assignedTo"
                      :options="dropdownOptions.assignedTo"
                      :set-selected="account.agent"
                      :has-placeholder="false"
                      @dropdownChange="registerChange($event, account)"
                    ></DropdownSelection>
                  </div>
                  <div class="generic-table__half-right-column">
                    <h3>
                      <strong>Update status of application</strong>
                    </h3>
                    <DropdownSelection
                      dropdown-name="status"
                      :options="dropdownOptions.status"
                      :set-selected="account.ark_status"
                      :has-placeholder="false"
                      @dropdownChange="registerChange($event, account)"
                    ></DropdownSelection>
                  </div>
                </div>

                <div
                  class="generic-table__flex-box generic-table__flex-right generic-table__flex-wrap"
                >
                  <button
                    class="button button--blue"
                    :disabled="!account.account_data_changed.all"
                    type="submit"
                  >
                    Save Changes
                  </button>
                  <div
                    v-if="checkAccountUpdate(account, 'fail')"
                    class="generic-table__submit-error"
                  >
                    <i class="fas fa-exclamation-triangle"></i>Update failed:
                    <span>Please try resubmitting the form</span>
                  </div>
                  <div
                    v-if="checkAccountUpdate(account, 'success')"
                    class="generic-table__submit-success"
                  >
                    <i class="fa fa-check-circle"></i>Successfully updated
                  </div>
                </div>
              </form>
            </template>
          </GenericTableRow>
        </GenericTable>

        <p v-else>We have no datas from the selected type.</p>
      </div>
    </div>

    <div class="manage-applications__right-column manage-applications__sidebar">
      <SidebarCard>
        <template #header>
          <i class="fas fa-info-circle manage-applications__info-icon"></i>
          Failed audit
        </template>
        <p>
          <strong>Documents not verified</strong><br />
          The customer was asked to provide evidence of their eligibility by a
          deadline. They have failed to prove their eligibility in time.
        </p>
        <p>
          <strong>Account closed</strong><br />
          The customer has left So Energy. They will not receive a broader group
          WHD payment.
        </p>
        <p>
          <strong>Core Group</strong><br />
          The customer will receive a WHD payment as the are eligible as part of
          Core Group. This broader group application has been closed.
        </p>

        <div
          class="manage-applications__select-all manage-applications__flex-box manage-applications__flex-right"
        >
          <button
            class="button button--blue select-button"
            :disabled="accountList.length === 0"
          >
            <input
              id="selectAllAcc"
              v-model="selectAll"
              type="checkbox"
              class="checkbox select-button__select-checkbox"
              :disabled="accountList.length === 0"
              @click="select"
            />
            <span>
              <template v-if="selectAll">
                All accounts selected
                <i class="fas fa-check manage-applications__check-icon"></i>
              </template>
              <template v-else> Select all accounts </template>
            </span>
          </button>
        </div>
      </SidebarCard>

      <SidebarCard>
        <template #header>Update status of application</template>
        <p class="manage-applications__selected">
          <strong>Accounts selected</strong>
          <span class="manage-applications__selected-total">
            {{ selectedAccounts.length }}
          </span>
        </p>

        <form @submit.prevent="submitStatusUpdate">
          <DropdownSelection
            dropdown-name="processTo"
            :options="dropdownOptions.status"
            placeholder="Please select"
            @dropdownChange="processApplications"
          ></DropdownSelection>

          <button
            class="button button--blue"
            :disabled="
              selectedAccounts.length === 0 ||
              processType.length === 0 ||
              pendingProcessing
            "
            type="submit"
          >
            Process
          </button>
        </form>

        <div class="manage-applications__process-container">
          <div
            v-if="failedToProcess"
            class="manage-applications__process manage-applications__process-failed"
          >
            <i class="fas fa-exclamation-triangle"></i>
            <span>Process failed, please retry</span>
          </div>

          <div
            v-if="pendingProcessing && !successfullyProcessed"
            class="manage-applications__loading"
          >
            <img src="@/assets/icons/loading-bar.gif" />
          </div>

          <div
            v-if="successfullyProcessed && !selectedAccounts.length"
            class="manage-applications__process manage-applications__process-successful"
          >
            <i class="fa fa-check-circle"></i>
            <span>Successfully processed</span>
          </div>
        </div>
      </SidebarCard>
    </div>

    <Modal
      :is-full-screen="true"
      :is-modal-open="isFilePreviewVisible"
      @closeModal="isFilePreviewVisible = false"
    >
      <template #body>
        <FilePreview :file-data="currentFile" />
        <p class="file-modal-text">{{ fileModalText }}</p>
      </template>
      <template #cancelButton>Close</template>
    </Modal>
  </div>
</template>

<script>
import { whdMixin } from "@/mixins/whdMixin"
import SidebarCard from "@/components/SidebarCard"
import GenericTable from "@/components/smartMeter/GenericTable"
import GenericTableRow from "@/components/smartMeter/GenericTableRow"
import DropdownSelection from "@/components/warmHomeDiscount/DropdownSelection"
import FilePreview from "@/components/FilePreview"
import Modal from "@soenergy/frontend-library/src/components/Modal"

export default {
  name: "ApplicationReceived",
  components: {
    SidebarCard,
    GenericTable,
    GenericTableRow,
    DropdownSelection,
    FilePreview,
    Modal,
  },
  mixins: [whdMixin],
  props: {
    accountList: {
      type: Array,
      default: () => [],
    },
    dropdownOptions: {
      type: Object,
      default: () => {},
    },
    loadMoreStatus: {
      type: Object,
      default: () => {},
    },
    failedProcessing: {
      type: Boolean,
      default: false,
    },
    pendingProcessing: {
      type: Boolean,
      default: false,
    },
    successfullyProcessed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      AuditAccountsHeader: [
        "",
        "Select",
        "Account Id",
        "Criteria 1",
        "Criteria 2",
        "Assigned",
        "Status",
      ],
      accounts: [],
      selectedAccounts: [],
      selectAll: false,
      processType: "",
      failedToProcess: this.failedProcessing,
      isFilePreviewVisible: false,
      currentFile: null,
    }
  },
  computed: {
    isLoadMoreShown() {
      return !this.searchSuccess
    },
    fileModalText() {
      const fileName = this.currentFile ? this.currentFile.name : ""
      return "Uploaded file: " + fileName
    },
  },
  watch: {
    accountList(value) {
      this.accounts = this.accountList.map((account) => ({
        account_data_changed: {
          cr1: false,
          cr2: false,
          agent: false,
          status: false,
          all: false,
          originalPrimaryCriteria: account.primary_whd_criterion_id,
        },
        accountUpdateFail: false,
        accountUpdateSuccess: false,
        ...account,
      }))
    },
    successfullyProcessed(value) {
      this.resetSelection()
    },
    failedProcessing(value) {
      this.failedToProcess = value
    },
  },
  methods: {
    resetSelection() {
      this.selectedAccounts = []
      this.failedToProcess = false
    },
    processApplications(selection) {
      switch (selection.name) {
        case "processTo":
          this.processType = selection.value
          break
        default:
          return
      }
    },
    submitStatusUpdate() {
      let submissionData = {
        processingTab: "closedApplication",
        data: {
          warm_home_discounts_interface: {
            account_numbers: this.selectedAccounts,
            new_attributes: {
              ark_status: this.processType,
            },
          },
        },
      }

      this.$emit("process-applications", submissionData)
    },
    getLabelClass(status) {
      let modifier = ""

      switch (status) {
        case "closed_account":
          modifier = ""
          break
        case "core_group":
          modifier = "generic-table__status--approved"
          break
        case "no_evidence_provided":
          modifier = ""
          break
        default:
          modifier = ""
      }
      return "generic-table__status " + modifier
    },
    getArkStatus(status) {
      let statusUppercase = status.charAt(0).toUpperCase() + status.slice(1)
      return statusUppercase.replaceAll("_", " ")
    },
    select() {
      this.selectedAccounts = []
      if (!this.selectAll) {
        for (let i in this.accountList) {
          this.selectedAccounts.push(this.accountList[i].junifer_account_number)
        }
      }
    },
    openProofModal(item) {
      this.isFilePreviewVisible = true
      this.currentFile = item
    },
  },
}
</script>

<style lang="scss">
.manage-applications {
  &__select-all {
    display: inline-block;
    margin-top: $spacing-4;

    label {
      border-radius: 20px;
      padding: $spacing-2 $spacing-4 $spacing-2 $spacing-2;
      font-weight: $weight-bold;

      &:hover {
        cursor: pointer;
      }
    }

    input {
      opacity: 0;
    }
  }

  &__check-icon {
    padding-left: $spacing-1;
  }
}

.generic-list {
  color: $water-dark;
  margin-top: 18px;
  margin-bottom: -$space-2;
}
</style>
